import * as analytics from '@anm/analytic';
import Button from '@anm/components/buttons/Button';
import { useEffect, FC } from 'react';

import { ButtonLink, DowngradeButtons } from '../../Wrapper';

import Wrapper, { Bold, Container, TitleBlockWrapper } from './Wrapper';

export type BenefitsStepProps = { onKeep: () => void; onCancel: () => void };

const BenefitsStep: FC<BenefitsStepProps> = ({ onKeep, onCancel }) => {
  useEffect(() => {
    analytics.trackCancelShowBenefits();
  }, []);

  return (
    <Wrapper>
      <TitleBlockWrapper direction="center" size="medium" title="Are you sure you want to cancel?" />
      <Container>
        <Bold>You will lose access to:</Bold>
        <ul>
          <li>Your uploaded videos and images in video editor and live streaming studio</li>
          <li>Projects you created with paid subscription</li>
          <li>Your embedded and hosted videos</li>
        </ul>
      </Container>

      <Container>
        <Bold> With Free plan you have only basic features:</Bold>
        <br />
        <Bold>Video editor</Bold> with watermark and lower quality export
        <ul>
          <li>No auto-captions, text-2-speech and other premium features </li>
        </ul>
        <Bold>Live-streaming</Bold> with watermark and just 1 camera
        <ul>
          <li>No multiple guests, cameras, streaming destinations</li>
          <li>No permissions, no scenes</li>
        </ul>
        <Bold>Video hosting</Bold> with watermark
      </Container>

      <DowngradeButtons>
        <Button size="big" variant="light-blue" onClick={onKeep}>
          Keep my plan
        </Button>
        <ButtonLink active size="big" variant="blue-link" onClick={onCancel}>
          Continue to cancellation
        </ButtonLink>
      </DowngradeButtons>
    </Wrapper>
  );
};

export default BenefitsStep;
